<section id="security" class="relative scroll-mt-28 overflow-hidden border-t border-surface">
    <app-landing-glow [variant]="7" />
    <div class="relative z-10 mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div class="max-w-3xl">
            <div class="text-sm font-semibold uppercase tracking-[0.3em] text-primary">{{ text().securityTitle }}</div>
            <h2 class="mt-4 text-3xl font-semibold text-surface-900 sm:text-4xl dark:text-white">{{ text().securitySubtitle }}</h2>
        </div>

        <div class="mt-10 grid gap-5 sm:grid-cols-2">
            @for (item of text().securityItems; track item.title; let i = $index) {
                <article [appRevealOnScroll]="i * 90" class="flex items-start gap-4 rounded-3xl border border-surface bg-surface-0 p-6 shadow-lg shadow-black/10 dark:bg-white/5">
                    <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-primary-100 text-xl text-primary dark:bg-primary-400/10">
                        <i [class]="'pi ' + securityIcons[i]"></i>
                    </div>
                    <div>
                        <h3 class="text-lg font-semibold text-surface-900 dark:text-white">{{ item.title }}</h3>
                        <p class="mt-2 leading-7 text-muted-color">{{ item.description }}</p>
                    </div>
                </article>
            }
        </div>
    </div>
</section>
